import { useMemo } from "react";
import { NormalizedCompany } from "~/types/search.types";
import { useCompanyStore, useDisclosureStore, useHelperStore } from "~/stores";

export const useCompanyKeywordSearch = () => {
    const allCompanies = useCompanyStore(state => state.companies);
    const allFilters = useCompanyStore(state => state.filters);
    const activeDisclosure = useDisclosureStore(state => state.disclosure);
    const keyword = useHelperStore(state => state.keyword);

    const checkKeywordMatch = (item: NormalizedCompany) => {
        if (!item) return false;

        const { name } = item;
        const companyName = name.toLowerCase();
        const isKeywordMatch = companyName.includes(keyword.toLowerCase());

        return isKeywordMatch;
    };

    const filteredCompanies = useMemo(() => {
        const companyResults = allCompanies.filter(item => checkKeywordMatch(item));
        const companyIds = companyResults.map(company => company.id);
        const filterResults = allFilters.filter(
            item =>
                companyIds.includes(item.companyId) &&
                item.disclosureId === activeDisclosure?.exploreId
        );
        return filterResults;
    }, [keyword, activeDisclosure]);

    return {
        filteredCompanies
    };
};
